import React from "react";

const MAP_TYPE_OPTIONS = [
  { id: "roadmap", label: "Map" },
  { id: "satellite", label: "Satellite" },
  { id: "hybrid", label: "Hybrid" },
];

export default function MapTypeControls({
  mapType,
  onChange,
  isPhoneMobile = false,
}) {
  return (
    <div
      style={{
        position: "absolute",
        top: 12,
        right: 12,
        zIndex: 20,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 6,
        maxWidth: isPhoneMobile ? "calc(100% - 24px)" : 320,
        padding: 6,
        borderRadius: 999,
        background: "rgba(255,255,255,0.88)",
        border: "1px solid rgba(255,255,255,0.72)",
        boxShadow: "0 16px 34px rgba(15,23,42,0.18)",
        boxSizing: "border-box",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        pointerEvents: "none",
      }}
      aria-label="Map view controls"
    >
      {MAP_TYPE_OPTIONS.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onChange(item.id)}
          style={{
            border: 0,
            borderRadius: 999,
            padding: isPhoneMobile ? "8px 10px" : "9px 12px",
            background: mapType === item.id ? "linear-gradient(135deg, #0f6fff 0%, #10b981 100%)" : "transparent",
            color: mapType === item.id ? "#fff" : "#475569",
            fontSize: 12,
            fontWeight: 900,
            cursor: "pointer",
            minHeight: 38,
            minWidth: 0,
            boxSizing: "border-box",
            whiteSpace: "nowrap",
            pointerEvents: "auto",
          }}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
